(ns web3.screens.details
  (:require [re-frame-simple.db :as db]
            [web3.queries.asset :as q-asset]
            [web3.screens.asset :as asset]
            [web3.screens.content :as content]
            [web3.screens.model :as model]
            [web3.screens.files :as files]
            [web3.view :as v]
            [web3.routers.app-helpers :as app-route]))

(defn lightbox-ids
  [{:keys [id __typename]}]
  (let [{:keys [handler route-params]} (db/get-in [:db/routers :router/root])]
    (case handler
      :group
      (let [{:keys [group-id]} route-params
            {{:keys [assets
                     contents]} :entity} (q-asset/asset-group {:id group-id})]
        (->> (case __typename
               "Asset" assets
               "Content" contents)
             (map :id)))
      :files/collection
      (->> route-params
           files/contents-sections
           (map :section)
           (mapcat :id))
      [])))

(defn query
  [{:keys [id __typename]}]
  (case __typename
    "Asset" (q-asset/asset {:id id})
    "Content" (q-asset/content {:id id})
    "Model" (q-asset/model-lookup {:id id})))

(defn wide?
  [{:keys [id __typename]}]
  (or (= "Asset" __typename)
      (= "Model" __typename)))

(defn next-href
  [route-params id]
  (-> route-params
      (assoc :id id)
      (app-route/details-href)))

(v/defview view
  {:modal-props {:id :id
                 :ids lightbox-ids
                 :class "bg-white"
                 :next-href next-href
                 :query query
                 :wide? wide?}}
  [{:keys [__typename] :as entity}]
  (let [view (case __typename
               "Content" content/content-details
               "Asset" asset/asset-page
               "Model" model/model-page)]
    [view
     entity]))